window.sprChatSettings = {"appId":"67368a922e7a7e3522cd6503_app_2105670","skin":"MODERN","disableAttachment":"true","disableAnalytics":"true"};
(function () {
  var a,
    r,
    n,
    o,
    i,
    s = window,
    e = s.sprChat;
  (e && e.loaded) ||
    ((a = document),
    ((r = function () {
      r.q.push(arguments);
    }).q = []),
    (s.sprChat = r),
    (s.sprChat.loaded = !0),
    (n = 0),
    (o = 'spr-live-chat-widget'),
    (i = function () {
      var e = a.getElementById(o),
        e = (e && e.parentNode.removeChild(e), a.createElement('script')),
        t =
          ((e.type = 'text/javascript'),
          (e.async = !0),
          (e.src = 'https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/' + s.sprChatSettings.appId),
          (e.id = o),
          (e.onerror = function (e) {
            var t, a;
            ++n <= 3
              ? setTimeout(i, 250)
              : ((s.sprChat.loaded = !1),
                (t = 'WIDGET_LOAD_FAILED'),
                (a = e),
                r.q
                  .map(function (e) {
                    if ('subscribeToUpdate' === e[0] && e[1] && 'loadCompleted' === e[1].topic) return e[1].subscriber;
                  })
                  .map(function (e) {
                    e && e({ response: { error: !0, errorPayload: { type: t, message: a } } });
                  }));
          }),
          a.getElementsByTagName('script')[0]);
      t.parentNode.insertBefore(e, t);
    }),
    'loading' !== a.readyState ? i() : a.addEventListener('DOMContentLoaded', i));
})();